import { FC, lazy, Suspense, useEffect, useMemo } from 'react'
import { useDevSettings } from 'common/services/useDevSettings'

type MailActionWarningType = {
  width?: number
  collapsed?: boolean
  height?: number
}

const MailActionWarning: FC<MailActionWarningType> = ({
  height = 40,
  width = 40,
  ...rest
}) => {
  const { devSettings } = useDevSettings()
  const whitelabel = devSettings.whitelabel

  // Memoize the dynamically imported component
  const DynamicMailActionWarning = useMemo(() => {
    return lazy(() =>
      import(`./${whitelabel || 'default'}`).catch(() => import(`./default`)),
    )
  }, [whitelabel])

  return (
    <Suspense fallback={null}>
      <DynamicMailActionWarning height={height} {...rest} />
    </Suspense>
  )
}

export default MailActionWarning
